import { Check } from "lucide-react";
import { useCallback } from "react";
import { getChecklist, setChecklistItem } from "@/lib/storage";
import useStorageSync from "@/hooks/useStoredState";

// Persisted checklist with large (>=44px) tap targets.
export default function Checklist({ slug, mode, phaseKey, items }) {
  const [state] = useStorageSync(() => getChecklist(slug, mode, phaseKey), [slug, mode, phaseKey]);

  const toggle = useCallback(
    (index) => {
      const current = getChecklist(slug, mode, phaseKey);
      setChecklistItem(slug, mode, phaseKey, index, !current[index]);
    },
    [slug, mode, phaseKey]
  );

  return (
    <ul className="space-y-3" data-testid="checklist">
      {items.map((item, i) => {
        const checked = !!state[i];
        const lines = String(item).split("\n");
        const header = lines[0];
        const bullets = lines.slice(1).filter((l) => l.trim() !== "");
        return (
          <li key={i}>
            <button
              type="button"
              data-testid={`checklist-item-${i}`}
              onClick={() => toggle(i)}
              className={`w-full flex items-start gap-3 text-left rounded-2xl border p-3 sm:p-4 min-h-[44px] transition-colors ${
                checked
                  ? "bg-brand-cream border-brand-orange/40"
                  : "bg-white border-brand-navy/10 hover:border-brand-orange/40"
              }`}
            >
              <span
                aria-hidden="true"
                className={`mt-0.5 flex-shrink-0 w-7 h-7 rounded-lg border-2 flex items-center justify-center transition-colors ${
                  checked ? "bg-brand-orange border-brand-orange" : "border-brand-navy/25 bg-white"
                }`}
              >
                {checked && <Check className="w-5 h-5 text-white" strokeWidth={3} />}
              </span>
              <span className={`text-[15px] sm:text-base leading-snug ${checked ? "text-brand-navy/60 line-through" : "text-brand-navy"}`}>
                {header}
                {bullets.length > 0 && (
                  <ul className="mt-2 space-y-1 pl-1">
                    {bullets.map((b, bi) => (
                      <li key={bi} className="flex items-start gap-2">
                        <span aria-hidden="true" className="mt-2 flex-shrink-0 w-1.5 h-1.5 rounded-full bg-brand-orange/70" />
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </span>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
